//
// locale_zh-TW.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/zh-TW.json';
import localeData from "react-intl/locale-data/zh.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_zh-TW.js